import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Button } from 'primeng/button';
import { IftaLabelModule } from 'primeng/iftalabel';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: [ './login.component.scss' ],
    imports: [
        FormsModule,
        Button,
        IftaLabelModule
    ]
})
export class LoginComponent implements OnInit {

    protected depTestURL: string | undefined = environment.depTestLogin;
    protected depURL: string = environment.depLogin;

    constructor(
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    /**
     * Initializes the component.
     * This method subscribes to the route's query parameters to check for a token.
     * If a token is found, it saves the token using the AuthService and redirects to the dashboard.
     * If no token is found, the login form will be displayed as usual.
     */
    public ngOnInit(): void {
        // Check if the token is present in the query parameters
        this.route.queryParams.subscribe(async params => {
            const token = params['token'];
            if (token) {
                // Save the token to local storage using the AuthService
                this.authService.saveToken(token);
                // Optionally update any user state here (for example, refresh the role)
                // Redirect the user to the dashboard
                await this.router.navigate([ '/' ]);
            }
            // If there's no token, the login form will be displayed as usual.
        });
    }
}
